exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset[data-v-430ea60c] {\n  border: none;\n}\n[data-v-430ea60c] .field-group {\n  margin-bottom: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 10px;\n}\n.modal-container[data-v-430ea60c] {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n", ""]);

// exports
